var _rect, _rect2, _path, _path2, _path3, _g, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglandFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 25,
    stroke: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3204_5925)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    transform: "translate(1 1)",
    fill: "#FF4E4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.00076 1L-4.00076 25L35.9992 25V1L-4.00076 1Z",
    fill: "#001E6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5272 13.0001L-4.89511 3.14677L-3.10626 -1.14648L15.9993 10.3169L35.1049 -1.14648L36.8937 3.14677L20.4714 13.0001L36.8937 22.8535L35.1049 27.1468L15.9993 15.6834L-3.10626 27.1468L-4.89511 22.8535L11.5272 13.0001Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3204_5925",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 1,
    width: 41,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9992 13L35.9992 13V25L15.9992 13ZM15.9992 13L15.9992 25L-4.00076 25L15.9992 13ZM15.9992 13L-4.00076 13L-4.00076 1L15.9992 13ZM15.9992 13V1L35.9992 1L15.9992 13Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3204_5925)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0178 13.0004L-4.59705 2.4315L-3.40448 -0.430664L15.9992 11.2116L35.403 -0.430664L36.5955 2.4315L18.9807 13.0004L36.5955 23.5693L35.403 26.4315L15.9992 14.7893L-3.40448 26.4315L-4.59705 23.5693L13.0178 13.0004Z",
    fill: "#C8102E"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6659 9V1L19.3326 1V9L35.9992 9V17L19.3326 17L19.3326 25L12.6659 25L12.6659 17L-4.00076 17L-4.00076 9L12.6659 9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9992 10.6V1L17.9992 1V10.6L35.9992 10.6V15.4L17.9992 15.4L17.9992 25L13.9992 25L13.9992 15.4L-4.00076 15.4L-4.00076 10.6L13.9992 10.6Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3204_5925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglandFlag);
export default __webpack_public_path__ + "static/media/england-flag.95de5f487c7aae5adcc25e8bbc97bf50.svg";
export { ForwardRef as ReactComponent };